import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { FormMode } from 'src/app/controls/common/form-mode';
import { Attribute } from 'src/app/models/attribute';
import { ListLayoutColumn } from 'src/app/models/list-layout-column';
import { AttributeDefinitionsService } from 'src/app/services/attribute-definitions.service';

@Component({
    selector: 'app-list-layout-column-form-dialog',
    templateUrl: './list-layout-column-form-dialog.component.html',
    styleUrls: ['./list-layout-column-form-dialog.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatOptionModule,
        MatCheckboxModule,
        MatButtonModule,
        NgClass,
        MatDialogClose,
    ],
})
export class ListLayoutColumnFormDialogComponent implements OnInit {
    public FormMode = FormMode;

    /**
     * Champs du formulaire de saisie du nom.
     */
    public attributeFormControl = new UntypedFormControl(null, Validators.required);
    public positionFormControl = new UntypedFormControl(null);
    public stickyFormControl = new UntypedFormControl(null);
    public sizeFormControl = new UntypedFormControl(null, Validators.required);
    public idFormControl = new UntypedFormControl(null);

    // public reminderActionDatasFormControl = new FormControl(null, Validators.required);

    public get isValid(): boolean {
        return this.attributeFormControl.valid && this.sizeFormControl.valid;
    }

    attributes: Attribute[];

    public title = "Ajout d'un alias";

    constructor(
        public dialogRef: MatDialogRef<ListLayoutColumnFormDialogComponent>,
        public attributesService: AttributeDefinitionsService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit(): void {
        this.loadAttributes();

        //this.idFormControl.disable();
        this.positionFormControl.disable();

        if (this.data.mode === FormMode.Reading) {
            this.attributeFormControl.disable();
            this.stickyFormControl.disable();
            this.sizeFormControl.disable();
        }

        if (this.data.mode === FormMode.Creation) {
            this.title = "Ajout d'une colonne";
        } else if (this.data.mode === FormMode.Edition) {
            this.title = `Édition de la colonne ${this.data.record.id}`;
        }
        if (this.data.mode === FormMode.Reading) {
            this.title = `Colonne ${this.data.record.id}`;
        }
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public validate(): void {
        if (this.isValid) {
            this.dialogRef.close(this.data.record);
        }
    }

    loadAttributes() {
        const existingColumns = (this.data.dataSource as AdvancedDataSource<ListLayoutColumn>).datas;

        this.attributesService.List(null, null, null, null).subscribe((x) => {
            if (this.data.mode === FormMode.Creation) {
                this.attributes = x.value.filter((y) => existingColumns.findIndex((z) => z.attributeId === y.id) === -1);
            } else {
                this.attributes = x.value;
            }
        });
    }
}
